import React from "react";
import { useAppSelector } from "../../store/hooks";
import SwitchRole from "../../components/SwitchRole";

export default function AdminDashboard() {
  const user = useAppSelector((s) => s.auth.user);
  const phone = user?.phone || "";
  const name = user?.name || "Admin";

  return (
    <div className="flex items-center justify-center h-full min-h-screen bg-gray-50">
      <div className="bg-white shadow-lg rounded-2xl p-10 text-center max-w-md w-full">
        <h1 className="text-3xl font-bold text-indigo-700 mb-4">
          Welcome, {name} 👋
        </h1>
        <p className="text-gray-600 mb-2">
          You are logged in as <span className="font-semibold text-indigo-600">Admin User</span>.
        </p>
        <p className="text-gray-500 text-sm">Phone: {phone}</p>
        <SwitchRole />
      </div>
    </div>
  );
}
